import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeftinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.327 8l4.787 4.702-1.401 1.426-5.514-5.415a1 1 0 0 1 0-1.426l5.514-5.415 1.401 1.426L6.327 8z",
		fill: "currentColor"
	})
});
export default SvgChevronLeftinline;
